<template>
    <div>
        <Table v-if="data.products" :fields="fields" :items="data.products" :filtered="filtered" type="List" :loading="loading"  noHeader mode="comp"/>
        <p v-else> Gösterilecek hiç ürün yok </p>
   </div>
</template>

<script>
let fields = [ 
        { key: 'barcode', label: 'Ürün Kodu', keys:['barcode']},
        { key: 'name', label: 'Ürün Adı', keys:['name']},
        { key: 'desc', label: 'Ürün Açıklaması', keys:['description'] },
        { key: 'status', type:"status_badge", label: 'Durum', keys:['active'] },
        { key: 'quantity', label: 'Durum', keys:['quantity'] },  
  ]; 

  let filtered = ['barcode',"name", 'status', 'desc', 'quantity']; 

    export default {
        name: "AccountDelete",
        data:function(){
            return{
                fields, filtered
            }
        },
        props:{
            data: Object,
            modalName: String,
            modalEvent: Function,
            save: Boolean,
            saveState: Function,
            formName: String
        },
        computed:{
            list() {
                return this.$store.getters.getserviceMoveProducts
            }
        },
        watch:{
            save: async function(data){
                this.saveState(false)
                this.modalEvent(false)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Dealer/modals/Products.vue